import React, { useContext, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../App';

export default function Navbar() {
  const { user, logout } = useContext(AuthContext);
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-logo">
          <span className="logo-check">&#10003;</span>
          VerificaIncentivi.it
        </Link>

        <button className="mobile-menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? '\u2715' : '\u2630'}
        </button>

        <ul className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <li><Link to="/" className={isActive('/')} onClick={() => setMenuOpen(false)}>Home</Link></li>
          <li><Link to="/incentivi" className={isActive('/incentivi')} onClick={() => setMenuOpen(false)}>Incentivi</Link></li>
          <li><Link to="/come-funziona" className={isActive('/come-funziona')} onClick={() => setMenuOpen(false)}>Come Funziona</Link></li>
          <li><Link to="/gestione-bandi" className={isActive('/gestione-bandi')} onClick={() => setMenuOpen(false)} style={location.pathname === '/gestione-bandi' ? {} : { color: '#16a34a', fontWeight: 600 }}>Gestione Bandi</Link></li>
          <li><Link to="/cessione-crediti" className={isActive('/cessione-crediti')} onClick={() => setMenuOpen(false)}>Cessione Crediti</Link></li>
          <li><Link to="/faq" className={isActive('/faq')} onClick={() => setMenuOpen(false)}>FAQ</Link></li>
          {user ? (
            <>
              <li><Link to="/dashboard" className={isActive('/dashboard')} onClick={() => setMenuOpen(false)}>Dashboard</Link></li>
              {user.ruolo === 'admin' && (
                <li><Link to="/admin" className={isActive('/admin')} onClick={() => setMenuOpen(false)}>Admin</Link></li>
              )}
              <li>
                <button onClick={() => { logout(); setMenuOpen(false); }} className="btn btn-sm btn-outline">Esci</button>
              </li>
            </>
          ) : (
            <>
              <li><Link to="/login" onClick={() => setMenuOpen(false)}>Accedi</Link></li>
              <li><Link to="/register" className="btn btn-sm btn-primary" onClick={() => setMenuOpen(false)}>Registrati Gratis</Link></li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
}
